import gql from 'graphql-tag'

export const GET_TIME_ENTRIES = gql`
  query($startISO: String!, $endISO: String!, $noChild: Boolean) {
    getTimeEntries(startISO: $startISO, endISO: $endISO, noChild: $noChild) {
      _id
      billable
      end
      originalComment
      comment
      originalDurationInHours
      durationInHours
      originalEntryDate
      originalPersonId
      originalProjectId
      entryDate
      projectId
      referenceId
      referenceType
      repliconTimesheetId
      source
      sourceId
      status
      deferToMonth
      start
      quickbooksInvoiceId
      creationWay
      eventTagId
      approveState {
        status
        rejectionReason
        modifiedBy
      }
    }
  }
`

export const GET_TIME_ENTRIES_AS_DELEGATE = gql`
  query($startISO: String!, $endISO: String!, $delegateId: String!, $noChild: Boolean) {
    getTimeEntries_asDelegate(
      startISO: $startISO
      endISO: $endISO
      delegateId: $delegateId
      noChild: $noChild
    ) {
      _id
      billable
      end
      deferToMonth
      originalComment
      originalDurationInHours
      originalEntryDate
      originalPersonId
      status
      originalProjectId
      referenceId
      entryDate
      referenceType
      repliconTimesheetId
      projectId
      source
      sourceId
      start
      quickbooksInvoiceId
      creationWay
      eventTagId
      approveState {
        status
        rejectionReason
        modifiedBy
      }
    }
  }
`

export const UPDATE_TIME_ENTRY = gql`
  mutation(
    $_id: String!
    $billable: String
    $end: String
    $originalComment: String
    $originalDurationInHours: Float
    $originalEntryDate: String
    $originalPersonId: String
    $originalProjectId: String
    $referenceId: String
    $referenceType: String
    $repliconTimesheetId: String
    $sourceId: String
    $start: String
    $eventTagId: String
    $approveState: ApproveStateInput
    $comment: String
    $durationInHours: Float
    $status: String
    $deferToMonth: String
    $quickbooksInvoiceId: String
    $shouldUpdateComment: Boolean
  ) {
    updateTimeEntry(
      _id: $_id
      billable: $billable
      end: $end
      originalComment: $originalComment
      originalDurationInHours: $originalDurationInHours
      originalEntryDate: $originalEntryDate
      originalPersonId: $originalPersonId
      originalProjectId: $originalProjectId
      referenceId: $referenceId
      referenceType: $referenceType
      repliconTimesheetId: $repliconTimesheetId
      sourceId: $sourceId
      start: $start
      eventTagId: $eventTagId
      approveState: $approveState
      comment: $comment
      durationInHours: $durationInHours
      status: $status
      deferToMonth: $deferToMonth
      quickbooksInvoiceId: $quickbooksInvoiceId
      shouldUpdateComment: $shouldUpdateComment
    ) {
      _id
      billable
      deferToMonth
      end
      originalComment
      comment
      entryDate
      originalDurationInHours
      durationInHours
      originalEntryDate
      originalPersonId
      originalProjectId
      referenceId
      referenceType
      repliconTimesheetId
      source
      status
      sourceId
      start
      quickbooksInvoiceId
      creationWay
      eventTagId
      projectId
      personId
      approveState {
        status
        rejectionReason
        modifiedBy
      }
    }
  }
`
export const SPLIT_TIME_ENTRY = gql`
  mutation($entryId: String!, $durationInHours: [Float!]!, $comment: String, $statusses: [String]) {
    splitTimeEntry(
      entryId: $entryId
      durationInHours: $durationInHours
      comment: $comment
      statusses: $statusses
    ) {
      child {
        _id
        billable
        end
        originalComment
        deferToMonth
        comment
        originalDurationInHours
        durationInHours
        originalEntryDate
        originalPersonId
        originalProjectId
        referenceId
        referenceType
        repliconTimesheetId
        source
        status
        sourceId
        start
        quickbooksInvoiceId
        creationWay
        eventTagId
        entryDate
        projectId
        personId
        approveState {
          status
          rejectionReason
          modifiedBy
        }
      }
      parent {
        _id
        billable
        end
        originalComment
        deferToMonth
        comment
        originalDurationInHours
        durationInHours
        originalEntryDate
        originalPersonId
        originalProjectId
        referenceId
        entryDate
        referenceType
        repliconTimesheetId
        source
        status
        sourceId
        start
        quickbooksInvoiceId
        creationWay
        eventTagId
        projectId
        personId
        approveState {
          status
          rejectionReason
          modifiedBy
        }
      }
    }
  }
`

export const UPDATE_TIME_ENTRY_AS_DELEGATE = gql`
  mutation(
    $delegateId: String!
    $_id: String!
    $billable: String
    $end: String
    $originalComment: String
    $originalDurationInHours: Float
    $originalEntryDate: String
    $originalPersonId: String
    $originalProjectId: String
    $referenceId: String
    $referenceType: String
    $repliconTimesheetId: String
    $sourceId: String
    $start: String
    $eventTagId: String
    $deferToMonth: String
    $approveState: ApproveStateInput
  ) {
    updateTimeEntry_asDelegate(
      delegateId: $delegateId
      _id: $_id
      billable: $billable
      end: $end
      originalComment: $originalComment
      originalDurationInHours: $originalDurationInHours
      originalEntryDate: $originalEntryDate
      originalPersonId: $originalPersonId
      originalProjectId: $originalProjectId
      referenceId: $referenceId
      referenceType: $referenceType
      repliconTimesheetId: $repliconTimesheetId
      sourceId: $sourceId
      start: $start
      eventTagId: $eventTagId
      deferToMonth: $deferToMonth
      approveState: $approveState
    ) {
      _id
      billable
      status
      end
      originalComment
      originalDurationInHours
      deferToMonth
      originalEntryDate
      originalPersonId
      originalProjectId
      referenceId
      referenceType
      repliconTimesheetId
      source
      sourceId
      entryDate
      comment
      durationInHours
      projectId
      personId
      start
      quickbooksInvoiceId
      creationWay
      eventTagId
      approveState {
        status
        rejectionReason
        modifiedBy
      }
    }
  }
`

export const DELETE_TIME_ENTRY = gql`
  mutation($_id: String!) {
    deleteTimeEntry(_id: $_id)
  }
`
export const DELETE_TIME_ENTRY_AS_DELEGATE = gql`
  mutation($_id: String!, $delegateId: String!) {
    deleteTimeEntry_asDelegate(_id: $_id, delegateId: $delegateId)
  }
`

export const CREATE_TIME_ENTRY = gql`
  mutation(
    $billable: String
    $end: String
    $originalComment: String
    $originalDurationInHours: Float
    $originalEntryDate: String
    $originalProjectId: String
    $referenceId: String
    $referenceType: String
    $repliconTimesheetId: String
    $sourceId: String
    $start: String
    $creationWay: String
    $eventTagId: String
  ) {
    createTimeEntry(
      billable: $billable
      end: $end
      originalComment: $originalComment
      originalDurationInHours: $originalDurationInHours
      originalEntryDate: $originalEntryDate
      originalProjectId: $originalProjectId
      referenceId: $referenceId
      referenceType: $referenceType
      repliconTimesheetId: $repliconTimesheetId
      sourceId: $sourceId
      start: $start
      creationWay: $creationWay
      eventTagId: $eventTagId
    ) {
      _id
      billable
      end
      originalComment
      originalDurationInHours
      originalEntryDate
      originalPersonId
      originalProjectId
      referenceId
      referenceType
      repliconTimesheetId
      source
      sourceId
      entryDate
      start
      quickbooksInvoiceId
      creationWay
      eventTagId
      approveState {
        status
        rejectionReason
        modifiedBy
      }
    }
  }
`

export const CREATE_TIME_ENTRY_AS_DELEGATE = gql`
  mutation(
    $delegateId: String!
    $billable: String
    $end: String
    $originalComment: String
    $originalDurationInHours: Float
    $originalEntryDate: String
    $originalProjectId: String
    $referenceId: String
    $referenceType: String
    $repliconTimesheetId: String
    $sourceId: String
    $start: String
    $creationWay: String
    $eventTagId: String
  ) {
    createTimeEntry_asDelegate(
      delegateId: $delegateId
      billable: $billable
      end: $end
      originalComment: $originalComment
      originalDurationInHours: $originalDurationInHours
      originalEntryDate: $originalEntryDate
      originalProjectId: $originalProjectId
      referenceId: $referenceId
      referenceType: $referenceType
      repliconTimesheetId: $repliconTimesheetId
      sourceId: $sourceId
      start: $start
      creationWay: $creationWay
      eventTagId: $eventTagId
    ) {
      _id
      billable
      end
      originalComment
      originalDurationInHours
      originalEntryDate
      originalPersonId
      entryDate

      originalProjectId
      referenceId
      referenceType
      repliconTimesheetId
      source
      sourceId
      start
      quickbooksInvoiceId
      creationWay
      eventTagId
      approveState {
        status
        rejectionReason
        modifiedBy
      }
    }
  }
`

export const GET_TIME_ENTRIES_BY_PROJECT = gql`
  query getTimeEntriesByProjectIds(
    $projectIds: [String!]!
    $repliconTimesheetId: [String]
    $approveState: String
    $onlyInActiveInvoice: Boolean
  ) {
    getTimeEntriesByProjectIds(
      projectIds: $projectIds
      repliconTimesheetId: $repliconTimesheetId
      approveState: $approveState
      onlyInActiveInvoice: $onlyInActiveInvoice
    ) {
      _id
      billable
      end
      comment
      originalComment
      status
      deferToMonth
      originalDurationInHours
      originalEntryDate
      originalPersonId
      originalProjectId
      referenceId
      referenceType
      repliconTimesheetId
      source
      sourceId
      entryDate
      start
      quickbooksInvoiceId
      creationWay
      eventTagId
      entryDate
      projectId
      personId
      durationInHours
      splitChildren
      approveState {
        status
        rejectionReason
        modifiedBy
      }
    }
  }
`

export const PROCESS_TIMESHEETS = gql`
  mutation processTimeEntries($entries: [ProcessTimeEntriesInput!]!) {
    processTimeEntries(entries: $entries) {
      entries {
        correction
        description
        feedback
      }
    }
  }
`
